import { styled } from 'styled-components';
import React, { useMemo } from 'react';
import { computeRemSize } from '@ydistri/theme';

interface AdministrationListItemNameProps {
  $minWidth?: string;
}

export const AdministrationListItemName = styled.div<AdministrationListItemNameProps>`
  font-size: 1.2rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
`;

export const Wrapper = styled.div`
  color: #878585;
  font-size: 1rem;
  line-height: ${computeRemSize(14)};
`;

export const AdministrationListItemCountWrapper = styled.span`
  display: inline-block;

  &:not(:last-child)::after {
    content: ',';
    margin-right: 0.4rem;
  }
`;

export interface AdministrationListItemCountProps {
  children: React.ReactNode;
}

const AdministrationListItemCount: React.FC<AdministrationListItemCountProps> = ({ children }) => {
  const body = useMemo(() => {
    return React.Children.toArray(children).map((item, index) => (
      <AdministrationListItemCountWrapper
        key={React.isValidElement(item) && item.key !== null ? item.key : index}
      >
        {item}
      </AdministrationListItemCountWrapper>
    ));
  }, [children]);

  return <Wrapper>{body}</Wrapper>;
};

export default AdministrationListItemCount;
